import {
    BANK_TYPE_OPTIONS,
    CURRENT_STRENGTH_OPTIONS,
    ROAD_TYPE_OPTIONS,
} from "./spotFormConstants";

export const CREATE_INITIAL_FORM_STATE = {
    title: "",
    latitude: "",
    longitude: "",
    description: "",
    roadType: "Нормальная",
    isWinterHole: false,
    isSpawningArea: false,
    tentAllowed: false,
    capacityPersons: "1",
    fishingFromShore: true,
    fishingFromBoat: false,
    nightFishingAllowed: false,
    suitableForChildren: false,
    hasParking: false,
    hasShelter: false,
    bankType: "",
    maxDepth: "",
    currentStrength: "Нет",
};

export function resolveBankType(value) {
    if (!value) return "";
    const normalized = String(value).trim().toLowerCase();
    return BANK_TYPE_OPTIONS.find((option) => option.toLowerCase() === normalized) || "";
}

export function buildFormStateFromSpot(spot) {
    if (!spot) {
        return null;
    }
    return {
        description: spot.description || "",
        roadType: ROAD_TYPE_OPTIONS.includes(spot.roadType) ? spot.roadType : ROAD_TYPE_OPTIONS[0],
        isWinterHole: !!spot.isWinterHole,
        isSpawningArea: !!spot.isSpawningArea,
        tentAllowed: !!spot.tentAllowed,
        capacityPersons: String(spot.capacityPersons ?? 1),
        fishingFromShore: spot.fishingFromShore !== false,
        fishingFromBoat: !!spot.fishingFromBoat,
        nightFishingAllowed: spot.nightFishingAllowed !== false,
        suitableForChildren: !!spot.suitableForChildren,
        hasParking: !!spot.hasParking,
        hasShelter: !!spot.hasShelter,
        bankType: resolveBankType(spot.bankType),
        maxDepth: spot.maxDepth ?? spot.place?.maxDepth ?? "",
        currentStrength: CURRENT_STRENGTH_OPTIONS.includes(spot.currentStrength) ? spot.currentStrength : "Нет",
        fishIds: new Set((spot.fish || []).map((f) => f.id)),
    };
}
